export default __webpack_public_path__ + "static/mother-098be1b7002f72331501ebeec29a2c2c.png";